import React from 'react';
import { Api } from '../../../lib/api';

import { Button, Modal, Table, List } from 'antd';

import { SearchOutlined } from '@ant-design/icons';

import TestStatusBadge from './TestStatusBadge';

class TestBlockResults extends React.PureComponent {
    state = {
        rows: [],
        columns: [],
        testResults: null,

        testPlanName: null,

        createdAt: null,
        mappingResults: [],

        testStatus: null,

        specVisible: false
    };

    async componentDidMount() {
        const { systemTime } = await Api.getSystem();

        Api.getResult(this.props.testBlockResult.id).then((results) => {
            if (results === undefined) {
                return;
            }

            const rows = results[0].measurements.rows;
            const columns = results[0].measurements.columns;

            const detectedMap = results[0].detectedMap;
            const expectedMap = results[0].expectedMap;
            const polarityFibers = results[0].polarityFibers;

            const testResults = results[0].testResults;

            let testPlanName = results[0].testBlock?.testPlan?.name;

            let testStatus = results[0].testStatus;

            let mappingResults = [];

            if (detectedMap != null) {
                const parsedExpectedMap = JSON.parse(expectedMap);
                const parsedDetectedMap = JSON.parse(detectedMap);
                mappingResults = parsedExpectedMap.map(function (value, index) {
                    const detectedMapIndex = polarityFibers.indexOf(index + 1);
                    
                    const expected = parseInt(value);
                    const detected = detectedMapIndex !== -1 ? parsedDetectedMap[detectedMapIndex] : null;
                    const passed = detectedMapIndex !== -1 ? expected === detected : true;

                    return {
                        expected: expected,
                        detected: detected,
                        passed: passed
                    };
                });
                mappingResults.unshift({ expected: 'Expected', detected: 'Detected', passed: true });
            }

            let createdAt =
                systemTime === 1
                    ? new Date(results[0].createdAt).toUTCString().slice(0, 26) + 'UTC'
                    : new Date(results[0].createdAt).toLocaleString();

            this.setState({
                rows,
                columns,
                testResults,
                testPlanName,
                createdAt,
                mappingResults,
                testStatus
            });
        });
    }

    renderColumnContent(value, row, tag) {
        return (
            <div
                style={{
                    width: '48px',
                    backgroundColor: row.status.includes(tag) ? '#E60013' : 'auto',
                    padding: '3px 0px 3px 0px',
                    borderRadius: '2px',
                    margin: '-3px auto'
                }}
            >
                <span
                    style={{
                        color: row.status.includes(tag) ? '#F5F5F5' : '#262626',
                        textAlign: 'center'
                    }}
                >
                    {value}
                </span>
            </div>
        );
    }

    addMeasurementColumn(measurementType, measurementSubType, wavelengths, columnHeaderText, columnHeaderSubscript, columns) {
        let subColumns = [];

        wavelengths.forEach((wavelength) => {
            const dataIndex = `${measurementType}${measurementSubType}-${wavelength}`;
            if (this.state.columns.includes(dataIndex)) {
                subColumns.push({
                    title: wavelength,
                    align: 'center',
                    dataIndex: dataIndex,
                    key: dataIndex,
                    render: (value, row) => this.renderColumnContent(value, row, dataIndex)
                });
            }
        });

        if (subColumns.length > 0) {
            columns.push({
                title: (
                    <React.Fragment>
                        {columnHeaderText}<sub>{columnHeaderSubscript}</sub>
                    </React.Fragment>
                ),
                children: subColumns
            });
        }
    }

    render() {
        let columns = [
            {
                title: 'Fiber',
                dataIndex: 'fiber',
                key: 'fiber'
            }
        ];

        const wavelengths = ['1310', '1490', '1550', '1625', '850', '1300'];
        const measurementTypes = [
            { type: 'il', header: 'IL' },
            { type: 'rl', header: 'RL' }
        ];
        const measurementSubTypes = [
            { subType: 'a', subscript: 'a' },
            { subType: 'b', subscript: 'b' },
            { subType: 'total', subscript: 'Total' }
        ];

        measurementTypes.forEach((measurement) => {
            measurementSubTypes.forEach((subType) => {
                this.addMeasurementColumn(
                    measurement.type,
                    subType.subType,
                    wavelengths,
                    measurement.header,
                    subType.subscript,
                    columns);
            });
        });

        if (this.state.columns.includes('length')) {
            columns.push({
                title: 'Length',
                align: 'center',
                dataIndex: 'length',
                key: 'length_1',
                render: (value) => {
                    return {
                        children: value
                    };
                }
            });
        }

        return (
            <div style={{ minHeight: '300px', transition: 'all 0.3s ease' }}>
                {(this.props.testBlockResult.type === 'RL1' || this.props.testBlockResult.type === 'IL/RL') && (
                    <div className="container box-shadow">
                        <Table
                            title={() => (
                                <div className="flex space-between">
                                    <div className="grid grid-2 w-25">
                                        <div className="flex">
                                            <div className="center-self">IL/RL</div>
                                        </div>
                                        <TestStatusBadge testStatus={this.state.testStatus} />
                                        <div>Test Plan:</div>
                                        <div>{this.state.testPlanName}</div>
                                    </div>
                                    <div>
                                        <div>&nbsp;{this.state.createdAt}</div>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button
                                                onClick={() => {
                                                    this.setState({ specVisible: true });
                                                }}
                                                shape="round"
                                                icon={<SearchOutlined />}
                                            >
                                                Results
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            )}
                            dataSource={this.state.rows}
                            columns={columns}
                            sticky={true}
                            bordered
                            pagination={false}
                        />
                    </div>
                )}
                {
                    this.props.testBlockResult.type !== 'RL1' &&
                    this.props.testBlockResult.type !== 'IL/RL' &&
                    this.props.testBlockResult.type !== 'PT1' &&
                    this.props.testBlockResult.type !== 'Polarity' && <div>NO block type</div>
                }
                {
                    (this.props.testBlockResult.type === 'PT1' || this.props.testBlockResult.type === 'Polarity') && (
                        <div className="container">
                            <div className="border-grey">
                                <div className="flex space-between container md">
                                    <div className="grid grid-2 w-25">
                                        <div className="flex">
                                            <div className="center-self">Polarity</div>
                                        </div>
                                        <TestStatusBadge testStatus={this.state.testStatus} />
                                        <div>Test Plan:</div>
                                        <div>{this.state.testPlanName}</div>
                                    </div>
                                    <div>
                                        <div>&nbsp;{this.state.createdAt}</div>
                                    </div>
                                </div>
                                <div>
                                    <List
                                        grid={{ gutter: 0 }}
                                        dataSource={this.state.mappingResults}
                                        style={{
                                            margin: '0px 0px 0px 0px'
                                        }}
                                        renderItem={(item) => (
                                            <List.Item>
                                                <div
                                                    style={{
                                                        width: this.state.mappingResults.indexOf(item) === 0 ? '120px' : '55px',
                                                        textAlign: 'center',
                                                        display: 'flex',
                                                        borderColor: '#F0F0F0',
                                                        borderStyle: 'solid',
                                                        borderWidth: 'thin',
                                                        height: '55px',
                                                        backgroundColor:
                                                            this.state.mappingResults.indexOf(item) === 0 ? '#FAFAFA' : 'auto',
                                                        margin: '0px -1px 0px 0px'
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width: this.state.mappingResults.indexOf(item) === 0 ? 'auto' : '36px',
                                                            padding: '3px 0px 3px 0px',
                                                            borderRadius: '2px',
                                                            margin: 'auto'
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                color: '#262626',
                                                                textAlign: 'center'
                                                            }}
                                                        >
                                                            {item.expected}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div
                                                    style={{
                                                        width: this.state.mappingResults.indexOf(item) === 0 ? '120px' : '55px',
                                                        textAlign: 'center',
                                                        display: 'flex',
                                                        borderColor: '#F0F0F0',
                                                        borderStyle: 'solid',
                                                        borderWidth: 'thin',
                                                        height: '55px',
                                                        backgroundColor:
                                                            this.state.mappingResults.indexOf(item) === 0 ? '#FAFAFA' : 'auto',
                                                        margin: '-1px -1px 0px 0px'
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width: this.state.mappingResults.indexOf(item) === 0 ? 'auto' : '36px',
                                                            backgroundColor:
                                                                this.state.mappingResults.indexOf(item) === 0 || item.passed
                                                                    ? 'auto'
                                                                    : '#E60013',
                                                            padding: '3px 0px 3px 0px',
                                                            borderRadius: '2px',
                                                            margin: 'auto'
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                color:
                                                                    this.state.mappingResults.indexOf(item) === 0 || item.passed
                                                                        ? '#262626'
                                                                        : '#F5F5F5',
                                                                textAlign: 'center'
                                                            }}
                                                        >
                                                            {item.detected}
                                                        </span>
                                                    </div>
                                                </div>
                                            </List.Item>
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    )
                }
                <React.Fragment>
                    <Modal
                        title="Test Results"
                        wrapClassName="test-results-modal"
                        open={this.state.specVisible}
                        onCancel={() => this.setState({ specVisible: false })}
                        footer={
                            <div className="footer">
                                <div className="buttons">
                                    <Button
                                        type="primary"
                                        onClick={() => {
                                            this.setState({ specVisible: false });
                                        }}
                                    >
                                        Close
                                    </Button>
                                </div>
                            </div>
                        }
                    >
                        {this.state.testResults !== null && (
                            <React.Fragment>
                                <div className="test-results-details">
                                    <Table
                                        dataSource={Object.entries(this.state.testResults)}
                                        pagination={false}
                                        showHeader={false}
                                        columns={[
                                            {
                                                title: 'Spec',
                                                key: 'Spec',
                                                render: (value) => (
                                                    <div>
                                                        <span
                                                            style={{
                                                                color: '#262626'
                                                            }}
                                                        >
                                                            {value[0]}
                                                        </span>
                                                    </div>
                                                )
                                            },
                                            {
                                                title: 'PassFail',
                                                key: 'PassFail',
                                                render: (value) => (
                                                    <div>
                                                        {value[1] ? (
                                                            <span className="pass">PASS</span>
                                                        ) : (
                                                            <span className="fail">FAIL</span>
                                                        )}
                                                    </div>
                                                )
                                            }
                                        ]}
                                    />
                                </div>
                            </React.Fragment>
                        )}
                    </Modal>
                </React.Fragment>
            </div>
        );
    }
}

export default TestBlockResults;
